export default __webpack_public_path__ + "static/media/logo.c5f78611.svg";